import {DirectoryItem, DirectoryItemCard} from "./DirectoryItemCard";

export type DirectorySectionProps = {
  title: string;
  description?: string;
  items: DirectoryItem[];
  onNavigate?: (href: string) => void;
};

/** A labelled, responsive group of directory destinations. */
export const DirectorySection = ({title, description, items, onNavigate}: DirectorySectionProps) => (
  <section>
    <div className="mb-4">
      <h2 className="font-[family-name:var(--ots-font-display)] text-base font-semibold text-[var(--ots-secondary)]">
        {title}
      </h2>
      {description && <p className="mt-1 text-sm text-[var(--ots-text-muted)]">{description}</p>}
    </div>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
      {items.map((item) => (
        <DirectoryItemCard key={item.id} item={item} onNavigate={onNavigate}/>
      ))}
    </div>
  </section>
);
